import React, { useContext } from 'react'
import { Upselling } from '../../components/upselling/upselling'
import { FeatureContext } from '../../context/useFeatureFlagContext'
import { useNavigate } from 'react-router-dom'
import { useUpselling } from '../../hooks/useUpselling'

export function Promotions() {
    const upselling = useUpselling()

    const navigate = useNavigate()

    const { features } = useContext(FeatureContext)

    const goToPromotions = () => {
        upselling.updateUpselling('drawer.promotions', true)

        const onClick = () => {
            navigate('/promotionMain')
        }

        onClick()
    }

    return (
        <Upselling
            active={features.drawer.promotions}
            feature={{
                image: require('../../assets/images/upselling/promotions.png'),
                title: 'Ya estas llegando a tus\npotenciales clientes con\ntus nuevas Promociones ',
                btn: {
                    title: 'Ir a promociones',
                    action: () => goToPromotions(),
                },
            }}
            pending={{
                headtitle: 'Promociones',
                title: 'Llega a más clientes potenciales con promociones',
                text: 'Aumenta tu visibilidad y atrae a más clientes con las promociones de amiPOS. Crea y gestiona ofertas especiales fácilmente desde nuestra plataforma, sin complicaciones. ¡Con nuestras promociones, tu negocio se destaca y capta la atención de más consumidores!',
                list: [
                    'Diseña promociones personalizadas en minutos',
                    'Aumenta la fidelidad de tus clientes con ofertas exclusivas',
                    'Incrementa tus ventas durante temporadas bajas',
                    'Notifica a tus clientes sobre nuevas promociones al instante',
                    'Gestiona todas tus promociones desde un solo lugar',
                ],
                // btn1: {
                //     title: 'Contratar',
                //     action: () => {
                //         navigate('/subscription')
                //     },
                // },
                btn2: {
                    title: 'Hablar con Ventas',
                    action: () => {
                        window.open(
                            'https://amipass.typeform.com/to/BcTVDWHf?typeform-source=amipass.atlassian.net',
                            '_blank'
                        )
                    },
                },
                image: require('../../assets/images/upselling/promotions.png'),
                contract: 'contratando el Plan Estándar y Pro',
            }}
        />
    )
}
